<template>
  <v-container fluid class="mt-0 pt-0" id="print">

    <v-container fluid>
      <v-row>
        <v-col cols="4">
          <img class="" height="140" :src="$store.state.company.imageUrl" alt="">
          <!-- <v-img
          lazy-src="https://picsum.photos/id/11/10/6"
          aspect-ratio="1"
          class="grey lighten-2"
          max-width="350"
          max-height="160"
          ></v-img> -->
        </v-col>
        <v-col cols="7" offset="1" class="">
          <v-row>
            <v-col rows="9">
              <div class="relative">
                Customer<br> Name:__________________________
                <span class="names">{{customerName}}</span>
              </div>                               
            </v-col>
            <v-col rows="3">
              <div class="relative">
                <br>Invoice:_______________ 
                <span class="names">{{invoiceNum}}</span>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col rows="9">
              <div class="relative">
                Technician<br> Name:__________________________
                <span class="names">{{techName}} </span>
              </div>           
            </v-col>
            <v-col rows="3">
              <div class="relative">
                <br>Date:__________________
                <span class="names">{{dateNow}}</span>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>


   <!--  <v-row>
      <v-col cols="3">
        <img class="" height="150" :src="$store.state.company.imageUrl" alt="">
      </v-col>
      <v-col cols="9">
        <v-col cols="6">
          <v-col cols="12" sm="6">
            <p class="text-capitalize">{{ customerName }} </p>
          </v-col>
          <v-col cols="12" sm="6" justify-end>
            <p class="text-capitalize">{{ invoiceNum }} </p>
          </v-col>
        </v-col>
        <v-col cols="6">
          <v-col cols="12" sm="6">
            <p class="text-capitalize">{{ techName }} </p> 
          </v-col>
          <v-col cols="12" sm="6">
            <p class="text-capitalize">{{ dateNow }} </p>
          </v-col>
        </v-col>
      </v-col>
    </v-row> -->

    <!-- Summary Section -->
    <v-row light>
      <v-col>
       <h4 class="text-left mb-3 mt-1 recommendations"><u>Recommendations/Diagnostics/Summary</u></h4>
       <!-- dividers here -->
       <p class="underline"></p>
       <p class="underline"></p>
       <p class="underline"></p>
       <p class="underline"></p>
       <p class="underline"></p>
       <p class="underline"></p>
       <p class="underline"></p>
       <p class="underline"></p>
       <h5 class="mt-0 mb-3" id="solutions"><u>Solutions:</u>
        <h6 v-if="option[1].isCap || option[2].isCap || option[3].isCap || option[4].isCap || option[5].isCap || option[6].isCap" class="caption text-right pr-4">** Includes Comfort Assurance Plan Membership Discount</h6>
        <h6 v-if="isTen" class="caption text-right pr-4">** Our Friends And Family Discount</h6>
        <h6 v-if="isFive" class="caption text-right pr-4">** Our Military / Comfort Assurance Plan New Installs Discount</h6>
        <h6 v-if="isEmployee" class="caption text-right pr-4">** Our Any Hour Employee Discount</h6>
        <h6 class="caption text-right pr-4">*** Prices Include Tax, Labor, Parts & One Year Warranty</h6>
      </h5>
    </v-col>
  </v-row>

  <!-- options -->
  <div id="optionContainer">
    <v-row>
      <v-col cols="12" class="mt-0 pt-0">
       <ul class="list-group">
        <li class="list-group-item w-100 mx-0 shade py-2" v-for="(s, i) in Object.keys(option).length" :key="i" v-if="option[s].itemsList.length != 0">      
          <v-row>
            <v-col cols="9" class="text-left mt-0 py-0">
             <h3 class="ml-1 mt-0 options">Option #{{s}})<span class="d-none d-sm-inline-block warranty">1 Year Warranty</span></h3>
             <ul class="descriptionList">
              <li class="myfont" v-for="(i, ind) in option[s].itemsList" :key="ind"> 
                <span class="text-capitalize description">+ {{i.description}}</span>
              </li>
            </ul>
          </v-col>

          <v-col cols="3" 
          v-if="option[s].sum <= 1000 || !financing"
          class="text-right mt-1 mb-0 pl-0 py-0">
          <p v-if="option[s].isCap || isTen || isFive || isEmployee" class="mbNone pricing"> {{ option[s].total }} </p>
          <p v-if="option[s].isCap" class="mbNone pricing">** <u> - {{ option[s].discount }} </u></p>
          <p v-if="!option[s].isCap && (isTen || isFive || isEmployee)" class="mbNone pricing">**<u> - {{ option[s].discount }} </u></p>
          <p class="pricing mbNone">Investment ( {{ option[s].sum }} )</p>
        </v-col>
        <!-- Financing -->
        <v-col cols="3" 
        v-if="option[s].sum >= 1000 && financing"
        class="text-right mt-1 mb-0 pl-0 py-0">
        <p class="pricing mbNone">Investment <br />{{ option[s].financeMonthlyPayment }} Per Month / {{option[s].financeAmount}}</p>
      </v-col>
    </v-row>

    <!-- <hr class="hrs" v-if="option[s].itemsList.length != 0"> -->
  </li>
</ul>
</v-col>
</v-row>
</div>
<!-- </v-container> -->
<!-- options end -->

<v-footer class="">
 <h2>{{company.footer | capitalize }}</h2>
 <h5>{{company.companyPhone}} / {{company.companyWebsite}}</h5>
</v-footer>  

</v-container>
<!-- container-fluid end print section-->

</template>

<script>
  import * as jsPDF from 'jspdf'
  import html2canvas from 'html2canvas'
  export default {
    props: ['option', 'techName', 'customerName', 'invoiceNum', 'dateNow', 'isFive', 'isTen', 'isEmployee', 'isCap', 'financing'],
    name: "print",
    data: () => ({

    }),
    computed: {
      company () {
        return this.$store.getters.company
      }
    },
    methods: {

    }

  }
</script>

<style scoped>

  span.warranty {
    padding: 4px 8px 4px 8px;
    font-size: .8em;
    float: right;
    border: 1px solid #666;
    border-radius: 50%;
    color: #666;
  }
  .list-group {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-direction: column;
    flex-direction: column;
    padding-left: 0;
    margin-bottom: 0
  }
  .list-group-item {
    position: relative;
    display: block;
    padding: .75rem 1.25rem;
    margin-bottom: -1px;
    background-color: #fff;
    border: 1px solid rgba(0, 0, 0, .125)
  }
  .list-group-item:first-child {
    border-top-left-radius: .25rem;
    border-top-right-radius: .25rem
  }
  .list-group-item:last-child {
    margin-bottom: 0;
    border-bottom-right-radius: .25rem;
    border-bottom-left-radius: .25rem
  }
  .names {
    position: absolute; 
    left: 80px; 
    bottom: 5px;
  }
  .relative {
    position: relative;
  }
</style>

